import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { AppInput, type AppInputProps } from 'app/javascript/components/ui/app-input';
import { cn } from 'app/javascript/utils';

type Props = AppInputProps & {
  id: string;
  label: string;
  /** 入力欄の左端に常時表示するアイコン（モックの ✉️ / 🔑 に相当） */
  icon?: LucideIcon;
};

/** ラベル付きの入力欄。label の for と input の id を紐付けて get_by_label で取れるようにする */
const AuthField: React.FC<Props> = ({ id, label, icon: Icon, className, ...inputProps }) => (
  <div className="mb-4">
    <label className="mb-1.5 block text-subtitle font-semibold text-tt-foreground-sub" htmlFor={id}>
      {label}
    </label>
    <div className="relative">
      {Icon && (
        <Icon
          aria-hidden="true"
          className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-tt-foreground-sub"
        />
      )}
      <AppInput id={id} className={cn(Icon && 'pl-9', className)} {...inputProps} />
    </div>
  </div>
);

export default AuthField;
